module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_Phishing.1bbe1a0e.svg";